export default __webpack_public_path__ + "static/step_07-8f8838a26b91dcf548f5b955e99233c4.png";